import {AbstractCondition} from '../../../core/job-runner/condition/abstract.condition';
import {JobContext} from '../../../core/job-runner/context/job.context';
import {RunnableEventRegistry} from '../../../core/job-runner/type/runnable-event.registry';

export class ReloadAssignmentsCondition extends AbstractCondition {
  isApplicable(context: JobContext): boolean {
    return context.event === RunnableEventRegistry.PostAssignmentAdded;
  }
}
